let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ferJ"), load("5ZaO3")]).then(() => parcelRequire('dpLKi'));